import { useRef } from 'react'
import styles from './index.module.less'

interface Iprops {
  multiple?: boolean
  accept?: string
  children: any
  beforeUpload?(file: File): Promise<File | null> | File | null
  onChange(files: File[]): void
  [key: string]: any
}

function FileUpload(props: Iprops) {
  const { accept = 'image/jpeg,image/jpg,image/png', children, beforeUpload, onChange, className } = props
  const uploader = useRef<any>(null)

  async function onFileChange(event: any) {
    const files = event.target.files
    let beforeUploadReturn = undefined
    if (beforeUpload && typeof beforeUpload === 'function') beforeUploadReturn = await beforeUpload(files)
    if (beforeUploadReturn === null) return

    onChange(files)
    uploader.current.value = null // 清空文件的值
  }

  function onUploadClick() {
    uploader.current?.click()
  }

  return (
    <>
      <input ref={ uploader }
        className={ styles["file-selector"] }
        type="file"
        accept={ accept }
        onChange={ onFileChange }
      />
      <div className={ `${styles["real-selector"]} ${className}` }
        onClick={ onUploadClick }>
        { children }
      </div>
    </>
  )
}

export default FileUpload
